import {AfterViewChecked, Directive, ElementRef, Input} from "@angular/core";

@Directive({
	selector: '[cpScrollIntoView]'
})
export class ScrollIntoViewDirective implements AfterViewChecked {
	@Input() scroll: boolean = false;

	public alreadyScrolled: boolean = false;

	constructor(public elementRef: ElementRef) { }

	public ngAfterViewChecked(): void {
		if (this.scroll && !this.alreadyScrolled) {
			this.elementRef.nativeElement.scrollIntoView({block: "nearest"});
			this.alreadyScrolled = true;
		}
	}
}
